export default "__VITE_ASSET__BB65z0NH__"